import React, { useState } from "react";
import ButtonGeneric from "../../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../../assets/png/bill.png";
import PagosController from "../../../../../../controllers/PagosController";
import { useForm } from "../../../../../../Hooks/UseForm";
import InputGeneric from "../../../../../../components/Inputs/InputGeneric";
import {
  optionPhone,
  optionPyment,
  pagoBancoVenezuela,
} from "../../../../../../propsType/Payemnts";
import SelectGeneric from "../../../../../../components/Inputs/SelectGeneric";
import { extrac } from "../../../../../../helpers/selectForm";
import { validatePagoVenezuela } from "../../../../../../validations/formValidations";
import Spinner from "../../../../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../../../../components/Modals/Modal";
import { UseContextApp } from "../../../../../../Global/Context/appContext";
import { InformationCircleIcon } from "@heroicons/react/outline";
import moment from "moment";

function BancoVenezuela({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {

  const { crearPagoBDV, procesarPagoBDV } = PagosController();
  const [{ user }] = UseContextApp();
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [check, setCheck] = useState(false);
  const [find, setFind] = useState(false);
  const [message, setMessage] = useState("");
  const [formCodigo, setFormCodigo] = useState({ codigo: "" });
  const [vlidateForm, setVlidateForm] = useState("");
  const [token, setToken] = useState("");
  const [svg, setSvg] = useState(null);
  const [imgModal, setImgModal] = useState(null);
  const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));
  const { form, errors, handleChange, handleSubmit, handleBlur } = useForm(pagoBancoVenezuela, validatePagoVenezuela, emailCliente);
  const generarCodigo = async () => {
    const result = handleSubmit();

    if (result === "ok") {
      setFormCodigo({ ...formCodigo, codigo: "" });
      setLoading(true);
      let dataCrearPago = {
        transaction: form.transaccion,
        cuenta: deatils.nroCuenta,
        monto: data.metodoAPagar,
        name: user.datos.nombreApellido,
        selectDoc: form.selectDoc,
        cedula: form.typeDoc,
        telefono: user.datos.telefono,
        correo: emailCliente,
        idTransaccion: Math.round(Math.random() * 10000000000),
      };
      let resCrearPagoBDV = await crearPagoBDV(dataCrearPago);

      if (resCrearPagoBDV) {
        switch (resCrearPagoBDV.responseCode) {
          case 0:
            if (resCrearPagoBDV.respuesta !== "100") {
              setData({ ...data, transactionRES: resCrearPagoBDV?.transactionId });
              setData({ ...data, transactionId: dataCrearPago.idTransaccion, emailBDV: dataCrearPago.correo, monto: dataCrearPago.monto, fecha: fechaNow });
              setToken(resCrearPagoBDV.paymentId);
              setLoading(false);
              setCheck(true);
              setSvg(true);
              setFind(false);
              setMessage("Introduzca el código del SMS enviado por BDV.");
              setImgModal("seccess");
            }
            else {
              setErrorModal(true);
              setSvg(false);
              setCheck(false);
              setImgModal("error");
              setLoading(false);
              setMessage(resCrearPagoBDV.descripcion);
              break;

            }
            break;
          default:
            setErrorModal(true);
            setSvg(false);
            setCheck(false);
            setImgModal("error");
            setLoading(false);
            setMessage(resCrearPagoBDV.responseDescription);
            break;
        }
      } else {
        setSvg(false);
        setLoading(false);
        setErrorModal(true);
        setImgModal("error");
        setMessage(resCrearPagoBDV.responseDescription);
      }
    }
  };
  const handleCodigo = (e) => {
    const { name, value } = e.target;
    setFormCodigo({
      ...formCodigo,
      [name]: value,
    });
  };
  
  function filtro(e) {
    if (form.selectDoc !== "P"){
      var tecla = e.key;
      if (['.', 'e','E' ].includes(tecla))
        e.preventDefault()}
  }
  const validateData = () => {
    setVlidateForm("");
    let isValid = true;
    if (formCodigo.codigo === "") {
      setVlidateForm("Debes ingresar una nombre");
      isValid = false;
    }
    return isValid;
  };
  const enviarPago = async () => {
    if (!validateData()) { return; }
    setLoadingModal(true);

    let dataPago = {
      idPago: token,
      codigoSms: formCodigo.codigo,
      tipoCuenta: form.tipoCuenta,
    };
    let resPagoBDV = await procesarPagoBDV(dataPago);

    if (resPagoBDV) {
      switch (resPagoBDV.responseCode) {
        case "0":
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          break;
        case "17":
          setErrorModal(true);
          setFind(false);
          setSvg(false);
          setMessage(resPagoBDV.responseDescription);
          setLoadingModal(false);
          break;
        default:
          setErrorModal(true);
          setSvg(false);
          setCheck(false);
          setImgModal("error");
          setLoadingModal(false);
          setMessage(resPagoBDV.responseDescription);
          break;
      }
    }
    else { setLoadingModal(false); }

  };
  const closetModal = () => {
    setCheck(false);
    setFind(false);
    setErrorModal(false);
    setFormCodigo({ ...formCodigo, codigo: "" });
  };
  const success = () => {
    setStapsState({
      ...stapsState,
      option1: false,
      option2: false,
      option3: false,
      option4: false,
      option5: true,
    });
  };

  return (
    <>
      <div className="flex lg:pt-[106px] pt-[200px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="lg:w-[70%]">
          {loading ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <Spinner title={"Espere..."} />
              </div>
            </>
          ) : (
            <>
              <div className="absolute left-0 top-0 w-full ">
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Pagar
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Completa la información y haz clic en pagar
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                <div className="grid lg:gap-[32px] gap-6 lg:relative lg:top-[10px] ">
                  <div className="flex flex-col lg:grid gap-5  lg:grid-cols-2">
                    <div className="grid">
                      <div className=" flex items-center gap-[3px] text-gray-900">
                        <p className="text-sm font-medium">
                          {" "}
                          Documento de Identidad
                        </p>
                        <p>
                          <div
                            className={` button cursor-pointer !w-[14px]`}
                            data-tooltip={
                              "Documento de identidad del titular de la cuenta Banco de Venezuela"
                            }
                          >
                            <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                          </div>
                        </p>
                      </div>
                      <div className="grid !mt-1  grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.selectDoc}
                            name={"selectDoc"}
                            onBlur={handleBlur}
                            errors={errors.selectDoc}
                            selectData={optionPyment}
                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "P" ? "text" : "number"}
                            onKeyDown={(e) => filtro(e)}
                            maxValue={13}
                            value={form.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors.typeDoc}
                          />
                        </div>
                      </div>
                    </div>
                    <InputGeneric
                      title={"Correo Electrónico"}
                      iconTop={true}
                      textTopTips={
                        "Correo electrónico para la recepción de la notificación o comprobante del pago"
                      }
                      name={"email"}
                      handleBlur={handleBlur}
                      onChange={e => setEmailCliente(e.target.value)}
                      errorText={errors.email}
                      value={emailCliente}
                    />
                  </div>

                  <div className="flex flex-col lg:grid gap-5  lg:grid-cols-2">

                    <InputGeneric
                      title={"Nombre del Titular del Servicio"}
                      disable={true}
                      placeholder={user?.datos?.nombreApellido}
                      onChange={handleChange}
                      name={"name"}
                      value={form.name}
                      errorText={errors.name}
                      handleBlur={handleBlur}
                    />

                    <div className="w-full space-y-1">
                      <div className=" flex items-center gap-[3px] text-gray-900">
                        <p className="text-sm font-medium">Tipo de Cuenta</p>
                        <p>
                          <div
                            className={` button cursor-pointer !w-[14px]`}
                            data-tooltip={
                              "Selecciona el tipo de cuenta desde donde se realiza el Pago Móvil"
                            }
                          >
                            <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                          </div>
                        </p>
                      </div>
                      <select
                        className={`
                        ${errors.tipoCuenta ? 'border-red-500 ' : 'border-gray-300 '}
                        bg-transparent border rounded-r-lg rounded-l-lg  text-gray-900 text-sm   focus:ring-blue-500 focus:border-blue-500  block w-full p-2.5`}
                        name="tipoCuenta"
                        onBlur={handleBlur}
                        value={form.tipoCuenta}
                        onChange={handleChange}
                      >
                        <option value="Seleccione">Seleccione</option>
                        <option value="1">Ahorro</option>
                        <option value="2">Corriente</option>
                      </select>
                    </div>
                  </div>

                  <div className="">
                    <p className="text-[0.8rem] text-[#798791]">
                      {" "}
                      Por favor asegúrese de colocar el documento de  identidad y tipo de cuenta correctos y registrados  en Banco de Venezuela, para una transacción  exitosa.
                    </p>

                  </div>
                  <div>
                    <hr className="pt-[10px] mt-[10px]" />
                  </div>
                </div>
                <div className="w-full flex justify-between gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric funtion={generarCodigo} text={"Pagar"} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   before:content-[''] 
                    before:absolute 
                    before:w-[45px] 
                    before:h-[45px] 
                    before:rounded-full 
                    before:bg-white 
                    before:bottom-[-20px]
                    before:left-[-20px]
                   
                    after:content-[''] 
                    after:absolute 
                    after:w-[45px] 
                    after:h-[45px] 
                    after:rounded-full 
                    after:bg-white 
                    after:bottom-[-20px]
                    after:right-[-20px] "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-20%] z-[8] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[90%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={bankInfo?.banco?.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {data?.metodoPago.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>{" "}
                <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>
          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div className="text-[#798791] ">Monto a Pagar</div>
                <div className="text-2xl font-medium">
                  <span className="text-[#798791] pr-2 ">Bs</span>
                  {data?.metodoAPagar}
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
        <Modal
          active={errorModal || check}
          setActive={setErrorModal}
          message={message}
          string={svg ? "check" : "error"}
          loading={loadingModal}
        >
          {loadingModal ? (
            <>
              <div className="pb-5">
                <Spinner title={"Pago en Proceso. Espere por favor."} />
              </div>
            </>
          ) : (
            <>
              <>
                {check && (
                  <>
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="flex justify-center items-center gap-6 ">
                        {!find && (
                          <div className="">
                            <InputGeneric
                              onChange={handleCodigo}
                              name={"codigo"}
                              defaultData={formCodigo?.codigo || ""}
                              value={formCodigo.codigo}
                              errorText={vlidateForm}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                {find ? (
                  <>
                    <>
                      <button
                        type="button"
                        onClick={success}
                        className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
                      >
                        Continuar
                      </button>
                      <button
                        type="button"
                        onClick={() => setCheck(false)}
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      >
                        Pagar de nuevo
                      </button>
                    </>
                  </>
                ) : (
                  <>
                    {check ? (
                      <>
                        <button
                          type="button"
                          onClick={enviarPago}
                          className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
                        >
                          Continuar
                        </button>
                        <button
                          type="button"
                          onClick={closetModal}
                          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        >
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          onClick={closetModal}
                          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        >
                          Cancelar
                        </button>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </Modal>
      </div>
    </>
  );
}

export default BancoVenezuela;
